import React from "react";
import { profile } from "../mock";
const Footer = ({}) => {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-[#0a0a0a] text-[#f4f1ea] border-t border-[#f4f1ea]/10">
      <div className="container-x py-10 flex items-center justify-between flex-wrap gap-4">
        <span className="font-mono text-xs text-[#f4f1ea]/55 flex items-center gap-2">
          <span className="w-2 h-2 bg-[#a01d3f]" />
          © {year} {profile.name || "Your Name"}. Crafted with care.
        </span>

        <span className="font-mono text-xs text-[#f4f1ea]/55">
          Designed and built by Uswa
        </span>
      </div>
    </footer>
  );
};

export default Footer;